import CreateAccount from '@/components/CreateAccount/CreateAccount';

export default CreateAccount;
